<script lang="ts" setup>
import { useEventBus } from '@vueuse/core'
import { ref } from 'vue'
import DTDialog from './DTDialog.vue'
import type { DialogEvent } from './types'

const dialogContainerId = ref(`DTDialogContainer-${crypto.randomUUID()}`)
const bus = useEventBus<DialogEvent>('dt_dialog')

const events = ref<DialogEvent[]>([])

const addListener = (event: DialogEvent) => {
  if (event.type !== 'add')
    return

  events.value.push(event)
}

const handleListener = (event: DialogEvent) => {
  if (event.type !== 'handle')
    return

  events.value = events.value.filter(e => e.id !== event.id)
  event.resolve(event.result)
}

bus.on(addListener)
bus.on(handleListener)

// eslint-disable-next-line unused-imports/no-unused-vars
const closeDialog = ({ type, ...rest }: DialogEvent, result?: boolean) => {
  bus.emit({ ...rest, type: 'handle', result })
}
</script>

<template>
  <div :id="dialogContainerId">
    <component
      :is="'component' in event.dialog ? event.dialog.component : DTDialog"
      v-for="event in events"
      :key="event.id"
      v-bind="'props' in event.dialog ? event.dialog.props : event.dialog"
      @close="(res: boolean | undefined) => closeDialog(event, res)"
    />
  </div>
</template>
